import { cva } from "class-variance-authority";

/**
 * Text Button Variants
 *
 * V&A Waterfront Design System - Text Button
 * Figma: UI Components / Buttons / Text
 *
 * All color tokens reference semantic aliases that auto-switch via .dark:
 *   Text-Primary    → Semantics/Colours/Text/Primary
 *   Text-Secondary  → Semantics/Colours/Text/Secondary
 *   Text-Interactive → Semantics/Colours/Text/Interactive (dark: Text/Primary)
 *   Text-Disabled   → Semantics/Colours/Text/Disabled
 *   Stroke-Primary  → Semantics/Colours/Brand/Primary
 *   Stroke-Interactive → Semantics/Colours/Borders/Colours/Interactive
 *   Stroke-Secondary → Semantics/Colours/Icons/Base/Secondary
 *   Stroke-Disabled → Semantics/Colours/Borders/Colours/Disabled
 *   Icon-Primary    → Semantics/Colours/Icons/Base/Primary
 *   Icon-Interactive → Semantics/Colours/Icons/Base/Interactive
 *   Icon-Disabled   → Semantics/Colours/Icons/Base/Disabled
 */

export const textButtonVariants = cva(
  [
    "group inline-flex items-center whitespace-nowrap",
    "transition-colors cursor-pointer",
    "disabled:pointer-events-none",
    "data-[disabled]:pointer-events-none",
    "[&_svg]:pointer-events-none [&_svg]:shrink-0",
    "focus:outline-none",
  ],
  {
    variants: {
      variant: {
        primary: [
          "text-text-primary border-brand-primary [&_svg]:text-icon-primary",
          "hover:text-text-interactive hover:border-border-interactive hover:[&_svg]:text-icon-interactive",
          "focus-visible:text-text-interactive focus-visible:border-border-interactive focus-visible:[&_svg]:text-icon-interactive",
          "disabled:text-text-disabled disabled:border-border-disabled disabled:[&_svg]:text-icon-disabled",
          "data-[disabled]:text-text-disabled data-[disabled]:border-border-disabled data-[disabled]:[&_svg]:text-icon-disabled",
        ],
        secondary: [
          "text-text-secondary border-icon-secondary [&_svg]:text-icon-secondary",
          "hover:text-text-interactive hover:border-border-interactive hover:[&_svg]:text-icon-interactive",
          "focus-visible:text-text-interactive focus-visible:border-border-interactive focus-visible:[&_svg]:text-icon-interactive",
          "disabled:text-text-disabled disabled:border-border-disabled disabled:[&_svg]:text-icon-disabled",
          "data-[disabled]:text-text-disabled data-[disabled]:border-border-disabled data-[disabled]:[&_svg]:text-icon-disabled",
        ],
      },
      size: {
        lg: [
          "gap-2",
          "py-3",
          "border-b",
          "typography-component-md-medium",
          "[&_svg]:size-5",
        ],
        md: [
          "gap-2",
          "py-3",
          "border-b",
          "typography-component-sm-medium",
          "[&_svg]:size-5",
        ],
        sm: [
          "gap-2",
          "py-3",
          "border-b",
          "typography-component-xs-medium",
          "[&_svg]:size-5",
        ],
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "lg",
    },
  },
);
